"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeferredQueueTableDefaultSort = [{
        dataField: 'submissionTime',
        order: 'desc'
    }];
//# sourceMappingURL=DeferredQueueTableDefaultSort.js.map